import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/content';
export function StatsBar() {
  return <section aria-label="Innebandy Ready i siffror" className="w-full bg-navy px-5 py-12 sm:px-8" data-id="element-196" data-mp="1tbjitu4bq6fx">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-4" data-id="element-197" data-mp="1oacb1v26l799">
        {stats.map((stat, index) => <Reveal key={stat.unit} delay={index * 0.06} data-id="element-198" data-mp="1jeer7erplirq" data-mpi={index}>
            <div className="flex flex-col items-center text-center" data-id="element-199" data-mp="1ee96kijuwwj5">
              <p className="font-serif text-5xl leading-none text-gold sm:text-6xl" data-id="element-200" data-mp="19mr4tsa0erx4">
                {stat.value}
              </p>
              <p className="mt-3 text-[10px] font-bold uppercase tracking-[0.16em] text-cream/75 sm:text-[11px]" data-id="element-201" data-mp="15lytmthkucy7">
                {stat.unit}
              </p>
            </div>
          </Reveal>)}
      </div>
    </section>;
}